(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alenne-cart-promise"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alenne-cart-promise')) {
    customElements.define('alenne-cart-promise', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        const mount = root => {
          const checkout = root.querySelector('#kaching-cart__checkout-button');
          if (!checkout || !root.querySelector('.kaching-cart__footer')) return;
          if (!root.querySelector('.alenne-cart-checkout-badge')) {
            checkout.after(this.querySelector('template').content.cloneNode(true));
          }
          root.querySelectorAll('.kaching-cart__footer > .kaching-cart__html-module').forEach(module => {
            const text = module.textContent.replace(/\s+/g, ' ').trim();
            if (text.includes('Free shipping across Australia') && text.includes('30-day money-back guarantee.')) {
              module.classList.add('alenne-cart-original-promise');
            }
          });
        };
        const connect = () => {
          const root = document.querySelector('#kaching-cart');
          if (!root) return false;
          this._root = root;
          this._cartObserver = new MutationObserver(() => mount(root));
          this._cartObserver.observe(root, {childList:true,subtree:true});
          mount(root);
          return true;
        };
        if (!connect()) {
          this._waitObserver = new MutationObserver(() => {
            if (connect()) this._waitObserver.disconnect();
          });
          this._waitObserver.observe(document.body, {childList:true,subtree:true});
        }
      }
      disconnectedCallback() {
        this._waitObserver?.disconnect();
        this._cartObserver?.disconnect();
        this._root?.querySelectorAll('.alenne-cart-checkout-badge').forEach(badge => badge.remove());
        this._root?.querySelectorAll('.alenne-cart-original-promise').forEach(module => module.classList.remove('alenne-cart-original-promise'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alenne-style-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alenne-style-videos')) {
    customElements.define('alenne-style-videos', class extends HTMLElement {
      connectedCallback() {
        this._observer?.disconnect();
        this._abort?.abort();
        this._resize?.disconnect();
        this._abort = new AbortController();
        const signal = this._abort.signal;
        const rail = this.querySelector('.alenne-style-videos__rail');
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        const update = () => {
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          const card = rail.querySelector('.alenne-style-videos__card');
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap);
          rail.scrollBy({left:Number(button.dataset.direction)*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }, {signal}));
        rail.addEventListener('scroll', update, {passive:true,signal});
        this._resize = new ResizeObserver(update);
        this._resize.observe(rail);
        update();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const auto = this.dataset.autoplay === 'true' && !reduceMotion && !navigator.connection?.saveData;
        const load = video => {
          video.muted = true;
          video.defaultMuted = true;
          if (!video.hasAttribute('src')) { video.src = video.dataset.videoSrc; video.load(); }
        };
        this._observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              load(video);
              if (auto) video.play().catch(() => {});
            } else { video.pause(); }
          });
        }, { threshold: 0.35 });
        this.querySelectorAll('video').forEach(video => {
          this._observer.observe(video);
          video.addEventListener('pointerdown', () => load(video), { once: true });
          video.addEventListener('focus', () => load(video), { once: true });
        });
      }
      disconnectedCallback() { this._observer?.disconnect(); this._resize?.disconnect(); this._abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
